import { ChatAPI } from '@guuru/chat-web';
import events from '@guuru/events-web';

const getChatSource = () => {
  const { refererTrigger } = ChatAPI.storeRetrieveParams();
  return refererTrigger || 'Direct';
};

const chatInit = {
  validate() {
    return true;
  },

  async render(partnerId) {
    const partner = await ChatAPI.getChatSettings(partnerId);
    const chatCategory = ChatAPI.storeRetrieveCategory();
    const locale = ChatAPI.storeRetrieveLocale();
    const chatChannel = ChatAPI.storeRetrieveChannel();
    const chatSource = getChatSource();
    events.setAnalyticsProperties({
      locale,
      partner: partnerId,
      account: partner.account,
      chatCategory,
      chatChannel,
      chatSource,
    });

    return { goToNextStep: true };
  },
};

export default chatInit;
